import colors from '../config/colors.json'
import { Scatter } from 'react-chartjs-2'

const EconomyChart = ({ match, annotations, height, summary }) => {
	return (
		<div className="charts__economy">
			<h1 className="charts__economy__title charts__title ">
				Economy Count
			</h1>
			<Scatter
				className=""
				height={height}
				style={{ maxHeight: height }}
				options={{
					maintainAspectRatio: false,
					aspectRatio: 1,
					animation: false,
					legend: {
						display: false,
					},
					title: {
						display: false,
					},
					scales: {
						x: {
							min: 20,
							ticks: {
								stepSize: 60,
								callback: (v) =>
									v >= 30 ? (v / 60).toString() + ' min' : '',
								color: 'white',
							},
							grid: {
								color: 'rgba(255,255,255,.3)',
							},
						},
						y: {
							beginAtZero: true,
							ticks: {
								color: 'white',
								font: { size: 20 },
							},
							grid: {
								color: 'rgba(255,255,255,.3)',
							},
							afterFit: (axis) => {
								axis.width = Math.max(axis.width, 60)
							},
						},
					},
					plugins: {
						legend: {
							display: false,
						},
						annotation: {
							annotations: annotations,
						},
					},
				}}
				data={{
					datasets: [
						{
							label: '',
							type: 'line',
							data: summary?.players[0].timeline.map((v) => ({
								x: v.time,
								y: v.population_economy,
							})),
							borderColor:
								colors[match.leftPlayer.color]?.mainColor,
							borderWidth: 4,
							pointRadius: 0,
						},

						{
							label: '',
							type: 'line',
							data: summary?.players[0].timeline.map((v) => ({
								x: v.time,
								y: v.population_economy_total,
							})),
							borderColor:
								colors[match.leftPlayer.color]?.secondaryColor,
							borderWidth: 4,
							pointRadius: 0,
							borderDash: [6, 6],
						},
						{
							label: '',
							type: 'line',
							data: summary?.players[1].timeline.map((v) => ({
								x: v.time,
								y: v.population_economy,
							})),
							borderColor:
								colors[match.rightPlayer.color]?.mainColor,
							borderWidth: 4,
							pointRadius: 0,
						},
						{
							label: '',
							type: 'line',
							data: summary?.players[1].timeline.map((v) => ({
								x: v.time,
								y: v.population_economy_total,
							})),
							borderColor:
								colors[match.rightPlayer.color]?.secondaryColor,
							borderWidth: 4,
							pointRadius: 0,
							borderDash: [6, 6],
						},
					],
				}}
			/>
		</div>
	)
}

export { EconomyChart }
